import { Button } from "@mui/material"
import dayjs from "dayjs"
import { collection, doc, getDoc, updateDoc } from "firebase/firestore"
import { db } from "../../../firebase"
import { toast } from 'react-toastify'
import { setIndividualStatus } from "./common"

type Props = {
  individualId: string
}

export const ProcessedButton = (props: Props) => {
  const { individualId } = props
  const individualDoc = doc(collection(db, 'individuals'), individualId)

  const updateStatus = async () => {
    if(!window.confirm("加工済みにしますか？")) return
    const doc = await getDoc(individualDoc)
    await updateDoc(individualDoc, setIndividualStatus({ ...doc.data(), processingDate: dayjs().format('YYYY/MM/DD'), updatedAt: dayjs().format('YYYY/MM/DD HH:mm') }))
      .then(() => {
        toast.success("加工済みに変更しました")
      }).catch(e => {
        toast.error(e)
      })
  }

  return (
    <Button variant="contained" color="success" size="small" onClick={() => updateStatus()}>加工済にする</Button>
  )
}
